import React from 'react';
import Input from '../../../components/ui/Input';
import { formatCurrencyInput } from '../../../utils/currencyFormatter';

const DirectCostsSection = ({ formData, errors, onChange }) => {
  const handleCurrencyInputChange = (field, rawValue) => {
    const formatted = formatCurrencyInput(rawValue);
    onChange(field, formatted);
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-bold text-foreground mb-6">O que você paga na obra</h3>
      <div className="space-y-5">
        <Input
          label="Custo do Empreiteiro"
          type="text"
          inputMode="decimal"
          placeholder="0,00"
          value={formData?.custoEmpreiteiro}
          onChange={(e) => handleCurrencyInputChange('custoEmpreiteiro', e?.target?.value)}
          error={errors?.custoEmpreiteiro}
          description="Valor pago ao empreiteiro"
          className="text-base"
        />
        
        <Input
          label="Equipe Mensal - Prestadores"
          type="text"
          inputMode="decimal"
          placeholder="0,00"
          value={formData?.equipeMensalPrestadores}
          onChange={(e) => handleCurrencyInputChange('equipeMensalPrestadores', e?.target?.value)}
          error={errors?.equipeMensalPrestadores}
          description="Custo mensal com MEIs e prestadores"
          className="text-base"
        />
        
        <Input
          label="Visitas à Obra - Total"
          type="text"
          inputMode="decimal"
          placeholder="0,00"
          value={formData?.visitasObraTotal}
          onChange={(e) => handleCurrencyInputChange('visitasObraTotal', e?.target?.value)}
          error={errors?.visitasObraTotal}
          description="Custo total de visitas técnicas"
          className="text-base"
        />
        
        <Input
          label="Outros Custos Diretos"
          type="text"
          inputMode="decimal"
          placeholder="0,00"
          value={formData?.outrosCustosDiretos}
          onChange={(e) => handleCurrencyInputChange('outrosCustosDiretos', e?.target?.value)}
          error={errors?.outrosCustosDiretos}
          description="Materiais, equipamentos, etc."
          className="text-base"
        />
      </div>
    </div>
  );
};

export default DirectCostsSection;